import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { whatIncluded, additionalCosts } from '@/mocks/pricingData';

export default function WhatIncluded() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-primary-900">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('pricing.included.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-400 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-50 tracking-[0.06em] mb-2">
            {t('pricing.included.title')}
          </h2>
          {String(t('pricing.included.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-400 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start max-w-[1600px] mx-auto">
          <div className="lg:w-[55%] order-2 lg:order-1">
            {String(t('pricing.included.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] md:text-[16px] text-foreground-300 tracking-[0.04em] leading-relaxed mb-8">{__s}</p>))}

            <div className="space-y-4">
              {whatIncluded.map((item, idx) => (
                <div
                  key={idx}
                  className="card-glow group flex gap-4 p-4 bg-primary-800/40 border border-primary-700/30"
                >
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-accent-400 text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-[16px] text-foreground-100 tracking-[0.05em] font-medium mb-1">
                      {lang === 'en' ? t(`pricing.included.${idx}.label`) : item.label}
                    </h3>
                    <p className="text-[14px] text-foreground-400 tracking-[0.03em] leading-relaxed">
                      {lang === 'en' ? t(`pricing.included.${idx}.desc`) : item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 p-4 border border-foreground-400/15 bg-primary-800/20">
              <p className="text-[14px] text-foreground-400 tracking-[0.04em] leading-relaxed mb-2">
                <strong className="text-foreground-300">{t('pricing.included.additionalTitle')}</strong>
              </p>
              <ul className="space-y-1">
                {additionalCosts.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-[13px] text-foreground-500 tracking-[0.03em]">
                    <span className="text-foreground-500 mt-0.5 flex-shrink-0">•</span>
                    {lang === 'en' ? t(`pricing.additionalCosts.${idx}`) : item}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="lg:w-[45%] order-1 lg:order-2 w-full">
            <div className="w-full h-[280px] md:h-[340px] overflow-hidden">
              <img
                src="/images/generated/pricing-included-2026.jpg"
                alt={t('pricing.included.imgAlt')}
                className="w-full h-full object-cover object-top"
              />
            </div>
            {String(t('pricing.included.imgCaption')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-foreground-500 tracking-[0.04em] mt-3 text-center">{__s}</p>))}
          </div>
        </div>
      </div>
    </section>
  );
}
